import { TaxIdFormat } from './tenant.domain';
import { DefaultLanguage } from '../translations/i18n';
export const DefaultTenantId = '2';
export const DefaultPrivacyPolicyUrl = 'https://net2phone.com/privacy-policy';

export enum AddressFormat {
  address = 1,
  lines,
  noZip,
  cep,
  street,
  countries,
  alphanumericZip,
  smallZip,
}

export interface ITenantConfig {
  language: string;
  dateFormat: string;
  addressFormat: AddressFormat;
  dateLanguage: string;
  currency: string;
  timeZone: string;
  targetStartDays: number;
  taxIdFormat: TaxIdFormat;
  validatePortDate: boolean;
  assistancePhoneNumber: string;
  culture: string;
  allowShipmentOptions: boolean;
  net2PhoneUrl: string;
  supportUrl?: string;
  privacyPolicyUrl?: string;
  newsUrl?: string;
  termsAndConditions?: string;
  facebookUrl?: string;
  twitterUrl?: string;
  linkedinUrl?: string;
  youtubeUrl?: string;
  blogUrl?: string;
  instagramUrl?: string;
  minZipLength: number;
  maxZipLength: number;
  isZipDigitsOnly: boolean;
  useAddressAutocomplete: boolean;
  autocompleteApiKey?: string;
  populateServiceInfo: boolean;
  populateShippingInfo: boolean;
  populateBillingInfo: boolean;
  displayNationalTaxId: boolean;
  displaySignerInformation: boolean;
  displaySignatoryPosition: boolean;
  displayNationalId: boolean;
  displayStateTaxId: boolean;
  displayInvoiceAnalysisFields: boolean;
  invoiceDueDays: string;
  nationalTaxIdMaxLength: number | undefined;
  nationalIdMaxLength: number | undefined;
  paymentOptions: string;
  displayPayment: boolean;
  country: string;
  displayServiceInfo: boolean;
  minPhoneNumberLength: number;
  maxPhoneNumberLength: number;
  useOnlyOneTargetDate: boolean;
  notDisplayShippingEmail: boolean;
  targetAddonStartDays: number | undefined;
  displayTimeRestriction: boolean;
  displayCityDropdown: boolean;
}

export class DefaultTenantConfig implements ITenantConfig {
  language: string = DefaultLanguage;
  dateFormat: string = 'MM/dd/yyyy';
  addressFormat: AddressFormat = AddressFormat.address;
  dateLanguage: string = DefaultLanguage;
  currency: string = 'USD';
  timeZone: string = 'America/New York';
  targetStartDays: number = 21;
  taxIdFormat: TaxIdFormat = TaxIdFormat.Brazil;
  validatePortDate: boolean = false;
  assistancePhoneNumber: string = '';
  culture: string = 'en-US';
  allowShipmentOptions: boolean = false;
  net2PhoneUrl: string = 'https://www.net2phone.com';
  minZipLength: number = 2;
  maxZipLength: number = 10;
  isZipDigitsOnly: boolean = false;
  useAddressAutocomplete: boolean = false;
  populateServiceInfo: boolean = false;
  populateShippingInfo: boolean = false;
  populateBillingInfo: boolean = false;
  displayNationalTaxId: boolean = false;
  displaySignerInformation: boolean = false;
  displaySignatoryPosition: boolean = false;
  displayNationalId: boolean = false;
  displayStateTaxId: boolean = false;
  displayInvoiceAnalysisFields: boolean = false;
  invoiceDueDays: string = '';
  nationalTaxIdMaxLength: undefined;
  nationalIdMaxLength: undefined;
  paymentOptions: string = 'Credit Card';
  displayPayment: boolean = true;
  country: string = 'US';
  privacyPolicyUrl: string = DefaultPrivacyPolicyUrl;
  displayServiceInfo: boolean = true;
  minPhoneNumberLength: number = 7;
  maxPhoneNumberLength: number = 40;
  useOnlyOneTargetDate: boolean = false;
  notDisplayShippingEmail: boolean = false;
  targetAddonStartDays: undefined;
  displayTimeRestriction: boolean = false;
  displayCityDropdown: boolean = false;
}
